import {
    getSessionStorageItemJson,
    SAILS_PARAM_PAYMENT_METHOD,
    SailsStoneStorage,
} from '@vfde-sails/storage';
import { SAILS_MULTICARD_STORAGE } from '@vfde-sails/constants';
import { PriceType } from '@vfde-sails/glados-v2';

/**
 * Get payment method
 */
export const getPaymentMethod = (storage?: SailsStoneStorage<PriceType> | null): PriceType | undefined => {
    storage = storage || getSessionStorageItemJson<SailsStoneStorage<PriceType> | null>(SAILS_MULTICARD_STORAGE);

    return storage?.[SAILS_PARAM_PAYMENT_METHOD];
};
